// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-3[data-v-2e0f436e]{gap:12px}.disabled-item[data-v-2e0f436e]{opacity:.5!important;pointer-events:none!important}", ""]);
// Exports
module.exports = exports;
